import axios from '../../plugins/axios';

export default {
    namespaced: true,

    state: {
        entities: [],
        entitiesCount: 0,
        entity: {}
    },

    mutations: {
        SET_ENTITIES(state, payload) {
            state.entities = payload;
        },
        SET_ENTITY(state, payload) {
            state.entity = payload;
        },
        CLEAR_ENTITY(state) {
            state.entity = {};
        },
    },

    actions: {
        async save({ commit, state }, { collection_id }) {
            let response = {};
            if(state.entity.id) {
                response = await axios.put(`/admin/collections/${collection_id}/sites/${ state.entity.id }`, state.entity);
            } else {
                response = await axios.post(`/admin/collections/${collection_id}/sites`, state.entity);
            }
            return response.data;
        },
        async delete({ commit }, { collection_id, id }) {
            await axios.delete(`/admin/collections/${collection_id}/sites/${ id }`);
        },
    },

    getters: {}
}
